module.exports = __webpack_public_path__ + "img/04.e8db6553.jpg";